import { createStore } from "vuex";
import PayOptions from "@/store/payOptionsStore.module";

export const store = createStore({
  modules: {
    payOptions: PayOptions,
  },
});
